module.exports = __webpack_public_path__ + "img/ondas.39ce74ed.png";